import React from "react";

import { SupCoin } from "@repo/core-ui";
import Link from "next/link";

export default function LayoutMenuInsurance() {
  return (
    <Link
      className="txt-16_24 flex h-12 items-center p-3 text-neutral-900 duration-100 hover:ease-in md:hover:bg-primary-75 md:hover:text-neutral-700 lg:flex"
      href="https://opencover.com/superform"
      target="_blank"
    >
      <span className="h-10 w-10 p-2">
        <SupCoin />
      </span>
      <span className="pr-4">Insurance</span>
    </Link>
  );
}
